







































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import * as _ from 'lodash';
import SearchDialog from '@/components/SearchDialog.vue';
import {
  getProducts,
  finish,
  complet,
  getAnomalyStocks,
  getAnomalyQuantitys,
} from '../../api/pickup';
import { removeFrontZone, insertString } from '../../utils/string';
import { getCurrentDate, getCurrentDatetime } from '../../utils/date';
import ProductChangeDialog from './components/ProductChangeDialog.vue';
import AnomalyQtyDialog from './components/AnomalyQtyDialog.vue';

enum tabEnum {
  pending = 0,
  issue = 1,
  completed = 2,
  all = 3,
}

interface IProductData {
  id: string;
  driver_name: string;
  driver_number: string;
  item_name: string;
  item_number: string;
  item_description: string;
  sales_unit: string;
  station_number: string;
  qty: number;
  status: number; // 0 pending, 1 completed, 2 assigned, 3 issue
  sort: number;
  merge_order_flag: number;
}

interface IProduct {
  id: string;
  name: string;
  description: string;
  actualQty: number;
  expectedQty: number;
}

@Component({
  name: 'Pickup',
  components: { ProductChangeDialog, AnomalyQtyDialog, SearchDialog },
})
export default class extends Vue {
  private date = '';

  private activeTab = 0;

  private search = '';

  private selected = [];

  private productData: IProductData[] = [];

  private anomalyStocks = [];

  private anomalyQuantitys = [];

  private longPressTimer: any;

  private beginDatetime = '';

  @Watch('activeTab')
  onChildChanged() {
    this.search = '';
    this.selected = [];
  }

  async created() {
    this.date = getCurrentDate();
    this.beginDatetime = getCurrentDatetime();
    try {
      this.$overlay(true);
      await this.getProducts();
      await this.getAnomalyStocks();
      await this.getAnomalyQuantitys();
    } finally {
      this.$overlay(false);
    }
  }

  async getProducts() {
    const { data } = await getProducts(this.date, this.$store.getters['user/locationCode']);
    this.productData = data;
  }

  async getAnomalyStocks() {
    const { data } = await getAnomalyStocks(this.date, this.$store.getters['user/locationCode']);
    this.anomalyStocks = data;
  }

  async getAnomalyQuantitys() {
    const { data } = await getAnomalyQuantitys(this.date, this.$store.getters['user/locationCode']);
    this.anomalyQuantitys = data;
  }

  private async finish() {
    let ids: string[] = [];
    this.pendingProducts.forEach((product) => {
      if (product.checked) {
        ids = _.concat(ids, product.ids);
      }
    });
    if (ids.length === 0) {
      this.$toast('请选择物料', { color: 'red', icon: 'fas fa-info-circle' });
      return;
    }
    try {
      this.$overlay(true);
      await finish(ids, this.beginDatetime, getCurrentDatetime());
      await this.getProducts();
      await this.getAnomalyStocks();
      await this.getAnomalyQuantitys();
    } finally {
      this.$overlay(false);
    }
  }

  private async completed() {
    let ids: string[] = [];
    this.issueProducts.forEach((product) => {
      if (product.checked) {
        ids = _.concat(ids, product.ids);
      }
    });
    if (ids.length === 0) {
      this.$toast('请选择物料', { color: 'red', icon: 'fas fa-info-circle' });
      return;
    }
    try {
      this.$overlay(true);
      await complet(ids, this.beginDatetime, getCurrentDatetime());
      await this.getProducts();
      await this.getAnomalyStocks();
      await this.getAnomalyQuantitys();
    } finally {
      this.$overlay(false);
    }
  }

  private backHandle() {
    this.$router.push({ name: 'PickupFilter' });
  }

  private groupByDriver(status = -1) {
    const productData = status === -1
      ? this.productData.slice()
      : this.productData.filter((product) => product.status === status);
    // 1. 连接司机名和站数
    const productsDriverStops = productData.map((product: any) => {
      product.driver_stops = `${product.driver_name}-${product.station_number}`;
      return product;
    });
    // 2. 根据司机名和站数分类
    const productsGroupDriver = _.groupBy(productsDriverStops, 'driver_stops');
    const productsGroup: IProduct[] = this.groupByProduct(productData);
    const drivers: any[] = [];
    let tableIndex = 1;
    _.forEach(productsGroupDriver, (products: IProductData[], driverStops) => {
      const driver: any = {};
      driver.index = tableIndex;
      driver.ids = [];
      driver.checked = false;
      const [driverName, stops] = _.split(driverStops, '-');
      driver.driver_name = driverName;
      driver.station_number = stops;
      products.forEach((product: IProductData) => {
        driver.ids.push(product.id);
        driver.driver_number = product.driver_number;
        driver.sort = product.sort;
        const index = productsGroup.findIndex((item) => item.id === product.item_number);
        if (index !== -1) {
          driver[`product${index}`] = driver[`product${index}`] === undefined ? 0 : driver[`product${index}`];
          driver[`product${index}`] += _.toNumber(product.qty);
          driver[`checked${index}`] = false;
          driver[`merge_order_flag${index}`] = product.merge_order_flag;
        }
        const anomalyQty = _.find(this.anomalyQuantitys, {
          driver_number: product.driver_number,
          item_number: product.item_number,
          station_number: driver.station_number,
        });
        if (anomalyQty) driver[`anomaly${index}`] = anomalyQty;
      });
      drivers.push(driver);
      tableIndex += 1;
    });

    return drivers;
  }

  private groupByProduct(productData: IProductData[]) {
    const products: IProduct[] = [];
    const groupByItem = _.groupBy(productData, 'item_number');
    _.forEach(groupByItem, (item, key) => {
      const expectedQty = _.sumBy(item, (sumItem) => _.toNumber(sumItem.qty));
      const stock: any = this.anomalyStocks.find(
        (anomalyStock: any) => anomalyStock.item_number === key,
      );
      const actualQty = stock === undefined ? expectedQty : _.toNumber(stock.actual_quantity);
      products.push({
        id: key,
        name: item[0].item_name,
        description: item[0].item_description,
        expectedQty,
        actualQty,
      });
    });
    return products;
  }

  private qtySubtotal(key: number) {
    const keyName = `product${key}`;
    const anomalyKeyName = `anomaly${key}`;
    let subtotal = 0;
    this.items.forEach((item) => {
      if (item[anomalyKeyName] !== undefined) {
        subtotal += _.toNumber(item[anomalyKeyName].quantity);
      } else if (item[keyName] !== undefined) {
        subtotal += item[keyName];
      }
    });
    return subtotal;
  }

  private async onProductChangeSave() {
    this.beginDatetime = getCurrentDatetime();
    try {
      this.$overlay(true);
      await this.getProducts();
      await this.getAnomalyStocks();
      await this.getAnomalyQuantitys();
    } finally {
      this.$overlay(false);
    }
  }

  get uniqueProducts() {
    const productData = this.productData.filter((product) => product.status === 2);
    return this.groupByProduct(productData);
  }

  private cellLongPress(item: any, key: any) {
    clearTimeout(this.longPressTimer);
    this.longPressTimer = 0;
    this.longPressTimer = setTimeout(() => {
      this.showAnomalyQtyDialog(item, key);
    }, 600);
  }

  private cellCancelPress() {
    clearTimeout(this.longPressTimer);
  }

  private showAnomalyQtyDialog(item: any, key: any) {
    const currentProduct = _.find(this.headers, { value: `product${key}` });
    const itemNumber = currentProduct !== undefined ? currentProduct.itemNumber : '';
    const itemName = currentProduct !== undefined ? currentProduct.itemName : '';
    const stationNumber = item.station_number;
    const expectedQty = item[`product${key}`];
    (this.$refs.AnomalyQtyDialog as Vue & {
      open(
        item: any,
        itemNumber: string,
        itemName: string,
        expectedQty: string,
        stationNumber: string,
      ): () => void;
    }).open(item, itemNumber, itemName, expectedQty, stationNumber);
  }

  private async onAnomalyQtySave(item: any) {
    try {
      this.$overlay(true);
      await this.getProducts();
      await this.getAnomalyStocks();
      await this.getAnomalyQuantitys();
    } finally {
      this.$overlay(false);
    }
  }

  private async onAnomalyQtyDestroy(item: any) {
    try {
      this.$overlay(true);
      await this.getProducts();
      await this.getAnomalyStocks();
      await this.getAnomalyQuantitys();
    } finally {
      this.$overlay(false);
    }
  }

  private cellClick(item: any, key: number) {
    if (item[`product${key}`]) {
      item[`checked${key}`] = !item[`checked${key}`];
      let checked = true;
      _.forIn(item, (val, keyName) => {
        if (_.startsWith(keyName, 'checked') && keyName !== 'checked' && item[keyName] === false) {
          checked = false;
        }
      });
      item.checked = checked;
    }
  }

  private rowCheckbox(item: any) {
    _.forIn(item, (val, keyName) => {
      if (_.startsWith(keyName, 'checked') && keyName !== 'checked') {
        item[keyName] = item.checked;
      }
    });
  }

  private productItemCount(productViews: any[]) {
    let itemCount = 0;
    productViews.forEach((productView: any) => {
      Object.keys(productView).forEach((keyName: string) => {
        if (_.startsWith(keyName, 'product')) {
          const num = parseInt(keyName.replace('product', ''), 0) + 1;
          itemCount = itemCount >= num ? itemCount : num;
        }
      });
    });
    return itemCount;
  }

  private productQtyCount(productViews: any[]) {
    let qtyCount = 0;
    productViews.forEach((productView: any) => {
      Object.keys(productView).forEach((keyName: string) => {
        if (_.startsWith(keyName, 'product')) {
          qtyCount += productView[keyName];
        }
      });
    });
    return qtyCount;
  }

  get height() {
    return window.innerHeight - 250;
  }

  get headers() {
    let productData: IProductData[] = [];
    switch (this.activeTab) {
      case tabEnum.pending:
        productData = this.productData.filter((product) => product.status === 2);
        break;
      case tabEnum.issue:
        productData = this.productData.filter((product) => product.status === 3);
        break;
      case tabEnum.completed:
        productData = this.productData.filter((product) => product.status === 1);
        break;
      case tabEnum.all:
        productData = this.productData.slice();
        break;
      default:
        return [];
    }
    const baseHeaders: any[] = [
      { text: 'Index', value: 'sort', align: 'center', width: 20 },
      { text: 'Driver Name', value: 'driver_name', align: 'center', width: 20 },
    ];
    if (this.activeTab === tabEnum.pending || this.activeTab === tabEnum.issue) {
      baseHeaders.unshift({ text: '', value: '', width: 10, align: 'center', sortable: false });
    }
    const productsGroup: IProduct[] = this.groupByProduct(productData);
    const headerStrLength = productsGroup.length <= 2 ? 16 : 8;
    productsGroup.forEach((product, key) => {
      const productNumber = removeFrontZone(product.id);
      const productName = `${_.replace(product.name, ' ', '')} ${_.replace(product.description, ' ', '')}`;
      const productNameSplit = insertString(productName, headerStrLength, '<br>');
      const actualQty = `${product.actualQty}/${product.expectedQty}`;
      baseHeaders.push({
        text: `${productNumber}<br>${productNameSplit}<br>${actualQty}`,
        value: `product${key}`,
        width: 100,
        class: 'customer-header',
        itemNumber: product.id,
        itemName: product.name,
        align: 'center',
        sortable: false,
      });
    });
    return baseHeaders;
  }

  get headersProduct() {
    return this.headers.filter(
      (header) => header.value !== null && header.value.indexOf('product') !== -1,
    );
  }

  get items() {
    switch (this.activeTab) {
      case tabEnum.pending:
        return this.pendingProducts;
      case tabEnum.issue:
        return this.issueProducts;
      case tabEnum.completed:
        return this.completedProducts;
      case tabEnum.all:
        return this.allProducts;
      default:
        return [];
    }
  }

  get pendingProducts() {
    return this.groupByDriver(2);
  }

  get issueProducts() {
    return this.groupByDriver(3);
  }

  get completedProducts() {
    return this.groupByDriver(1);
  }

  get allProducts() {
    return this.groupByDriver();
  }
}
